import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import App from './App';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

const tagManagerArgs = {
	gtmId: process.env.REACT_APP_GTM_ID
};
TagManager.initialize(tagManagerArgs);

Bugsnag.start({
	apiKey: process.env.REACT_APP_BUGS_NAG_KEY || '',
	enabledReleaseStages: ['production'],
	releaseStage: process.env.REACT_APP_ENV,
	plugins: [new BugsnagPluginReact()]
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
